export default __webpack_public_path__ + "static/media/icon3.dd9fdc76.svg";